import {MessageList} from "./MessageList.jsx"
import {useSelector} from "react-redux"

export const Messages = () => {
  const session = useSelector(state => state.imManagerSettings.selectedSession)
  return <MessageList key={session.id} session={session} />
}
